"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getILTProgressStatusFromCompletionStatus_1 = require("../helpers/getILTProgressStatusFromCompletionStatus");
const getState_1 = require("../helpers/getState");
// @ts-ignore: maintain function signature
function updateProgressStatusForIlt(command, user, content, states) {
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    state.progressStatus = getILTProgressStatusFromCompletionStatus_1.getILTProgressStatusFromCompletionStatus(state);
}
exports.updateProgressStatusForIlt = updateProgressStatusForIlt;
//# sourceMappingURL=updateProgressStatusForIlt.js.map